<template>
	<div>
		<div class="select date-options">
			<select v-model="dateRange" class="gtm-date-range-selector">
				<option
					v-for="(option, index) in dateOptions"
					:key="index"
					:value="option.value"
				>
					{{ option.label }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
import subDays from "date-fns/subDays";
import { date_server } from "@lab/utils/format";
import { mapGetters, mapActions } from "vuex";

export default {
	name: "DateFilter",
	data() {
		return {};
	},
	computed: {
		...mapGetters({
			reportDateRange: "reportQueries/dateRange",
			dateOptions: "reportFilters/dateOptions"
		}),
		dateRange: {
			get() {
				return this.reportDateRange;
			},
			set(range) {
				this.setDateRange(range);
			}
		}
	},
	watch: {
		dateRange(value) {
			if (value !== "custom") {
				let date = subDays(new Date(), value);
				this.setStartDate(date_server(date));
			}
		}
	},
	methods: {
		...mapActions({
			setDateRange: "reportQueries/setDateRange",
			setStartDate: "reportQueries/setStartDate",
			setEndDate: "reportQueries/setEndDate"
		})
	}
};
</script>

<style scoped></style>
